import React, { useState, useEffect, useRef } from 'react';
import axiosJWT from '../../secureAPI/axiosJWT';
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import useNavigation from '../../common/useNavigation';
import DataTable from 'react-data-table-component';
import PropTypes from 'prop-types';
import xlsimg from '../../assets/images/xls.png';
import { FaFolderOpen } from 'react-icons/fa';
import { Filetype } from '../../common/CommonFunctions';
import useMutation from './useMutation';
import { showToast } from '../../Utils/toastUtils';
import { BiRightArrowAlt } from 'react-icons/bi';

// const URL = `${process.env.REACT_APP_BASE_URL}/api/UploadDocExcel`;
// Define columns for the DataTable



const ExcelUpload = (props) => {

    const { navigateDashboard } = useNavigation();

    const [isfileuploded, setisFileuploded] = useState(false);
    const [fileList, setFileList] = useState([]);
    const [loading, setLoading] = useState(false);

    const [fileitem, setFileitem] = useState([]);
    const [errorList, setErrorList] = useState("");
    const [userAttributesList, setUserAttributesList] = useState([]);
    const [finalUserAttributesList, setFinalUserAttributesList] = useState([]);

    const wrapperRef = useRef(null);

    const { mutate: uploadImage, isLoading: uploading, error: uploadError } = useMutation()
    const onDragEnter = () => wrapperRef.current.classList.add('dragover');
    const onDragLeave = () => wrapperRef.current.classList.add('dragover');
    const onDrop = (e) => {
        wrapperRef.current.classList.add('dragover');
        e.preventDefault();
        e.stopPropagation();
    };


    const onFileDrop = async (e) => {
        let count = fileList.length;
        // console.log(count);
        if (count === 0) {
            setFileList([]);
            const newFile = e.target.files[0];
            if (newFile) {

                setLoading(true);


                const updatedList = [...fileList, newFile];
                let checking = Filetype(updatedList[0]['type'], newFile.type);
                if (checking === 1) {

                    const data = await newFile.arrayBuffer();
                    const wb = XLSX.read(data);
                    const worksheet = wb.Sheets[wb.SheetNames[0]];
                    const jsonDataHeader = XLSX.utils.sheet_to_json(worksheet, { header: 1, defval: "" });
                    const jsonData = XLSX.utils.sheet_to_json(worksheet);
                    // console.log({jsonData:jsonData});

                    // setColumns(jsonDataHeader[0]);

                    await getUserAttributes();

                    setFileitem(jsonData);
                    // console.log(jsonData);

                    setFileList(updatedList);
                    props.onFileChange(updatedList);
                    const formData = new FormData();
                    // formData.append("UID", userUID);
                    formData.append('Excelsheet', newFile, newFile.name);
                    await uploadImage(formData);

                    // console.log({ jsonData: jsonData });


                    setisFileuploded(true);
                    setTimeout(async () => {
                        // await bulkupload(jsonData);
                        setLoading(false);
                    }, 3000);
                }
                else {
                    setErrorList("File Must be .xlsx formate OR .csv formate !!");
                }
            }
        }
    }

    function checkArrayofAttributes() {
        // console.log({ userAttributesList: userAttributesList });

        let is_product_sku_exists = userAttributesList.some(obj => obj.attributeName === "Product_Code_SKU");
        let is_product_name_exists = userAttributesList.some(obj => obj.attributeName === "Product_Name");
        if (is_product_sku_exists) {
            finalUserAttributesList.push({ attributes_name: 'Product SKU' });
        }
        if (is_product_name_exists) {
            finalUserAttributesList.push({ attributes_name: 'Product Name' });

        }

    }



    const getUserAttributes = async () => {
        // setisLoading(true);
        await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/GetUserProductAttributes`, {}, { withCredentials: true, credentials: 'include' })
            .then((res) => {
                // console.log(res.data.data);
                setUserAttributesList(res.data.data);
                checkArrayofAttributes();

                // setisLoading(false);
                //settoastify({ status: '0', msg: 'ops...Something went wrong ! please try after sometime ' });
            })
            .catch((err) => {
                //    console.log(err);
                //setisLoading(false);
                //settoastify({ status: '0', msg: 'ops...Something went wrong ! please try after sometime ' });
            });
    }
    // Dummy data with blank cells in different places


    const [editingCell, setEditingCell] = useState({ rowIndex: null, field: null });

    const editableCell = (row, rowIndex, field) => {
        const isEditing =
            editingCell.rowIndex === rowIndex && editingCell.field === field;

        if (isEditing) {
            return (
                <input
                    type="number"
                    value={row[field] || ""}
                    onChange={(e) => handleInputChange(rowIndex, field, e.target.value)}
                    onBlur={() => setEditingCell({ rowIndex: null, field: null })} // जब बाहर क्लिक करो तो edit mode बंद
                    autoFocus
                    className="border border-gray-300 rounded px-2 py-1 w-24"
                />
            );
        }

        return (
            <div className="flex items-center space-x-2">
                <span>{row[field] || "—"}</span>
                <button
                    onClick={() => setEditingCell({ rowIndex, field })}
                    className="text-blue-600 hover:underline text-sm"
                >
                    Edit
                </button>
            </div>
        );
    };

    // ====================

    const columns = [
        {
            label: 'Product_Code_SKU',
            name: 'Product SKU',
            selector: row => row.Product_Code_SKU,
            sortable: true,
            reorder: true,
        },
        {
            label: 'Product_Name',
            name: 'Product Name',
            selector: row => row.Product_Name,
            sortable: true,
            reorder: true,
        },
        {
            label: 'Product_category',
            name: 'Product Main category',
            selector: row => row.Product_category,
            sortable: true,

            reorder: true,
        },
        {
            label: 'Product_sub_category_1',
            name: 'Product sub category 1',
            selector: row => row.Product_sub_category_1,
            sortable: true,

            reorder: true,
        },
        {
            label: 'Product_sub_category_2',
            name: 'Product sub category 2',
            selector: row => row.Product_sub_category_2,
            sortable: true,

            reorder: true,
        },
        {
            label: 'Product_sub_category_3',
            name: 'Product sub category 3',
            selector: row => row.Product_sub_category_3,
            sortable: true,

            reorder: true,
        },
        {
            label: 'Product_sub_category_4',
            name: 'Product sub category 4',
            selector: row => row.Product_sub_category_4,
            sortable: true,

            reorder: true,
        },
        {
            label: 'Product_sub_category_5',
            name: 'Product sub category 5',
            selector: row => row.Product_sub_category_5,
            sortable: true,

            reorder: true,
        },
        {
            label: 'Product_sub_category_6',
            name: 'Product sub category 6',
            selector: row => row.Product_sub_category_6,
            sortable: true,

            reorder: true,
        },
        {
            label: 'Product_sub_category_7',
            name: 'Product sub category 7',
            selector: row => row.Product_sub_category_7,
            sortable: true,

            reorder: true,
        },
        {
            label: 'Product_sub_category_8',
            name: 'Product sub category 8',
            selector: row => row.Product_sub_category_8,
            sortable: true,

            reorder: true,
        },
        {
            label: 'Product_sub_category_9',
            name: 'Product sub category 9',
            selector: row => row.Product_sub_category_9,
            sortable: true,

            reorder: true,
        },
        {
            label: "Selling_unit",
            name: "Selling Unit",
            cell: (row, rowIndex) => editableCell(row, rowIndex, "Selling_unit"),
            sortable: true,
            reorder: true,
        },
        {
            label: "Shipping_units",
            name: "Shipping Units",
            cell: (row, rowIndex) => editableCell(row, rowIndex, "Shipping_units"),
            sortable: true,
            reorder: true,
        },
        {
            label: 'Product_Minimum_Order_Quantity',
            name: 'Product MOQ(minimum order Quantity)',
            selector: row => row.Product_Minimum_Order_Quantity,
            sortable: true,

            reorder: true,
        },

        {
            label: 'Product_Short_Description',
            name: 'Product Short Description',
            selector: row => row.Product_Short_Description,
            sortable: true,

            reorder: true,
        },
        {
            label: 'Product_Short_Description',
            name: 'Product Long Description',
            selector: row => row.Product_Short_Description,
            sortable: true,

            reorder: true,
        },

        {
            label: 'HSN_Code',
            name: 'HSN Code',
            selector: row => row.HSN_Code,
            sortable: true,

            reorder: true,
        },
        {
            label: 'product_warrenty',
            name: 'Warrenty',
            selector: row => row.product_warrenty,
            sortable: true,

            reorder: true,
        },
        {
            label: 'product_link',
            name: 'Product Links',
            selector: row => row.product_link,
            sortable: true,

            reorder: true,
        },
        {
            label: 'product_stock',
            name: 'Product Stocks',
            selector: row => row.product_stock,
            sortable: true,

            reorder: true,
        },

        {
            label: 'product_variant',
            name: 'Product Variant',
            selector: row => row.product_variant,
            sortable: true,

            reorder: true,
        },
        {
            label: 'product_id',
            name: 'Product ID',
            selector: row => row.product_id,
            sortable: true,

            reorder: true,
        },
        {
            label: 'product_mrp',
            name: 'MRP',
            selector: row => row.product_mrp,
            sortable: true,

            reorder: true,
        },
        {
            label: 'product_price',
            name: 'Prices',
            selector: row => row.product_price,
            sortable: true,

            reorder: true,
        },
    ];

    const filteredColumns = columns.filter((column) =>
        userAttributesList.some((attr) => attr.attributeName === column.label)
    );

    const handleInputChange = (rowIndex, field, value) => {
        const updatedData = [...fileitem];
        updatedData[rowIndex][field] = value === "" ? "" : Number(value);
        setFileitem(updatedData);
    };

    const validateRow = (row) => {
        const isInvalidSelling =
            row.Selling_unit === null ||
            row.Selling_unit === "" ||
            isNaN(Number(row.Selling_unit));

        const isInvalidShipping =
            row.Shipping_units === null ||
            row.Shipping_units === "" ||
            isNaN(Number(row.Shipping_units));

        return isInvalidSelling || isInvalidShipping;
    };


    const conditionalRowStyless = [
        {
            when: (row) => validateRow(row),
            style: {
                backgroundColor: "rgba(255, 0, 0, 0.2)", // light red bg
                color: "black",
                fontWeight: "bold",
            },
        },
    ];


    const bulkupload = async () => {

        const invalidProducts = fileitem.filter((item) => {
            const isInvalidSelling =
                item.Selling_unit === null ||
                item.Selling_unit === "" ||
                typeof item.Selling_unit !== "number";

            const isInvalidShipping =
                item.Shipping_units === null ||
                item.Shipping_units === "" ||
                typeof item.Shipping_units !== "number";

            return isInvalidSelling || isInvalidShipping;
        });


        if (invalidProducts.length > 0) {
            const codes = invalidProducts.map((p) => p.Product_Code_SKU).join(", ");

            showToast(`Invalid Selling/Shipping units in products: ${codes}`, 'error')

            return false; // validation fail
        } else {

            await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/BulkUploadProduct`, { data: fileitem }, { withCredentials: true, credentials: 'include' })
                .then((res) => {
                    if (res.data.success === 1) {
                        navigateDashboard("seller")
                    }
                    // console.log('posting data', res.data);
                })
                .catch((err) => {
                    // console.log(err);
                });
        }

    }

    return (
        <div >
            {loading ? (
                // Loader
                <div className="flex flex-col items-center">
                    <div className="w-10 h-10 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
                    <p className="mt-3 text-gray-600 font-medium">Uploading file...</p>
                </div>
            ) : (

                <div>
                    {(isfileuploded) ?
                        //  <DataTable
                        //     columns={filteredColumns}
                        //     data={fileitem}
                        //     // conditionalRowStyles={conditionalRowStyles} // Apply conditional row styles based on blank data
                        //     onColumnOrderChange={cols => console.log(cols)}
                        // /> 

                        <div className='border'>
                            <DataTable
                                columns={filteredColumns}
                                data={fileitem}
                                conditionalRowStyles={conditionalRowStyless}
                                highlightOnHover
                                pointerOnHover
                            />

                            <div className='m-4 flex justify-end'>

                                <button type="submit" className="relative rounded-md group px-3 h-12 flex space-x-2 items-center bg-button-color hover:bg-button-color w-auto max-w-full"
                                    onClick={bulkupload}
                                >
                                    <span className="relative text-md text-black font-semibold mr-10">Continue</span>
                                    <div className="flex items-center h-12 w-12 rounded-full bg-button-color absolute right-0 z-20 drop-shadow-2xl">
                                        <BiRightArrowAlt className="h-5 w-5 text-black translate-x-4 transition duration-300 group-hover:scale-[2]" />
                                    </div>
                                </button>
                            </div>

                        </div>
                        : <div ref={wrapperRef} onDragEnter={onDragEnter} onDragLeave={onDragLeave} onDrop={onDrop}
                            className="m-auto drop-file-input relative w-[50%] h-72 border-[1px] border-dashed border-gray-400 rounded-2xl hover:opacity-60 bg-gray-100">
                            <div className='drop-file-input__label text-center text-theme-color-text font-semibold p-3'>
                                <img src={xlsimg} width={70} className='ml-[45%]' />
                                <p className=' py-2 text-gray-600'>Select your Excel file </p> <br />

                                <button className='btn btn-primary my-2  px-6 flex flex-row ml-[39%]  '>Choose File  <FaFolderOpen className='m-auto ml-2' /> </button>
                            </div>
                            <input type="file" value="" onChange={onFileDrop} className='opacity-0 absolute top-0 left-0 w-full h-full cursor-pointer ' />
                        </div>}
                </div>
            )}
        </div>
    );
};
ExcelUpload.propTypes = {
    onFileChange: PropTypes.func.isRequired,
    // onUpload: PropTypes.func.isRequired,
}
export default ExcelUpload;
